// Simple line-level diff helper for side-by-side SOP comparison
// Uses classic LCS to align lines, then classifies each row as same | added | removed | changed.
export function lineDiff(oldText, newText) {
  const a = (oldText || "").split(/\r?\n/);
  const b = (newText || "").split(/\r?\n/);
  const m = a.length, n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--)
    for (let j = n - 1; j >= 0; j--)
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
  const rows = [];
  let i = 0, j = 0;
  while (i < m && j < n) {
    if (a[i] === b[j]) { rows.push({ type: "same", old: a[i], new: b[j], _oi: i, _ni: j }); i++; j++; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { rows.push({ type: "removed", old: a[i], new: "", _oi: i, _ni: -1 }); i++; }
    else { rows.push({ type: "added", old: "", new: b[j], _oi: -1, _ni: j }); j++; }
  }
  while (i < m) { rows.push({ type: "removed", old: a[i], new: "", _oi: i, _ni: -1 }); i++; }
  while (j < n) { rows.push({ type: "added", old: "", new: b[j], _oi: -1, _ni: j }); j++; }
  // Merge adjacent removed+added into "changed" for cleaner rendering
  const out = [];
  for (let k = 0; k < rows.length; k++) {
    if (rows[k].type === "removed" && rows[k + 1] && rows[k + 1].type === "added") {
      out.push({ type: "changed", old: rows[k].old, new: rows[k + 1].new, _oi: rows[k]._oi, _ni: rows[k + 1]._ni });
      k++;
    } else out.push(rows[k]);
  }
  // Stable identity: type + line indices survive reorders and re-runs
  out.forEach((r) => { r.id = `${r.type}-${r._oi}-${r._ni}`; });
  const stats = out.reduce((s, r) => ({
    same: s.same + (r.type === "same" ? 1 : 0),
    added: s.added + (r.type === "added" ? 1 : 0),
    removed: s.removed + (r.type === "removed" ? 1 : 0),
    changed: s.changed + (r.type === "changed" ? 1 : 0),
  }), { same: 0, added: 0, removed: 0, changed: 0 });
  return { rows: out, stats };
}
